const createRicosFunctionalExtension = (extension) => extension;
export {
  createRicosFunctionalExtension
};
//# sourceMappingURL=create-ricos-functional-extension.js.map
